import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { RepairEstimate } from 'src/app/models/repair-estimate';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { MnrUserDepotmappingService } from 'src/app/services/mnr-user-depotmapping.service';

@Component({
  selector: 'logzy-survey-pending-form',
  templateUrl: './survey-pending-form.component.html',
  styleUrls: ['./survey-pending-form.component.scss']
})
export class SurveyPendingFormComponent implements OnInit {
  loader: boolean = true;
  update: boolean = false;
  repair_estimateList: MatTableDataSource<RepairEstimate>
  pageLength = 0;
  pageSize = 10;
  pageIndex = 0;
  searchText = new BehaviorSubject<string>('');
  displayedColumns: string[] = ['container_number', 'container_size_type', 'condition', 'address', 'csc_plate_number', 'csc_expiry_date', 'primary_port2', 'mnr_status', 'isEdit', 'isEdit1', 'isEdit2', 'isEdit3'];
  mnr_url = `${ApiRoutes.MNR}mnr_dashboard/`;

  data = [
    {
      container_number: "first",
      container_size_type: "01/01/2019",
      condition: false,
      address: false,
      csc_plate_number: "first",
      csc_expiry_date: "01/01/2019",
      primary_port2: false,
      mnr_status: false,
      isEdit: "qwert",
      isEdit1: "qwert",
      isEdit2: "qwert",
      isEdit3: "qwert",
    },
    {
      container_number: "first",
      container_size_type: "01/01/2019",
      condition: false,
      address: false,
      csc_plate_number: "first",
      csc_expiry_date: "01/01/2019",
      primary_port2: false,
      mnr_status: false,
      isEdit: "qwert",
      isEdit1: "qwert",
      isEdit2: "qwert",
      isEdit3: "qwert",
    },

  ]

  /// This could refactor
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private mnrService: MnrUserDepotmappingService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.refreshRepairestimate();
  }

  dataSource = this.data;

  ngAfterViewInit() {
    if (this.repair_estimateList != null || this.repair_estimateList != undefined) {
      this.repair_estimateList.paginator = this.paginator;
      this.repair_estimateList.sort = this.sort;
    }
  }
  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    this.update = true;
    switch (sortState.direction) {
      case 'asc':
        this.refreshRepairestimate();
        break;

      case 'desc':
        this.refreshRepairestimate();
        break;

      default:
        this.refreshRepairestimate();
    }
  }

  pageChanged(event: PageEvent) {
    this.update = true;
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.refreshRepairestimate();
  }
  previousPage() {
    this.router.navigateByUrl(`/master-data/mnr-master`);
    // this.resizeMatCard = false;
  }

  refreshRepairestimate() {
    this.mnrService.getRepairEstimate().subscribe({
      next: response => {
        console.log("survey pending", response);
        this.repair_estimateList = new MatTableDataSource<any>();
        this.pageLength = this.repair_estimateList.data.length;
      }
    })
  }
  // refreshRepairestimateLineItem() {
  //   this.mnrService.getRepairEstimateLineItem().subscribe({
  //     next: response => {
  //       console.log("survey pending", response);
  //       this.repair_estimateList = new MatTableDataSource<any>();
  //       this.pageLength = this.repair_estimateList.data.length;
  //     }
  //   })
  // }

  @ViewChild(MatTable) table: MatTable<any>;
  add(): void {
    this.dataSource.unshift({
      container_number: "first",
      container_size_type: "01/01/2019",
      condition: false,
      address: false,
      csc_plate_number: "first",
      csc_expiry_date: "01/01/2019",
      primary_port2: false,
      mnr_status: false,
      isEdit: "qwert",
      isEdit1: "qwert",
      isEdit2: "qwert",
      isEdit3: "qwert",
    });
    this.table.renderRows();
  }

}
